import React from "react";

export default function RequestApi({ onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: "#6b21a8",
        color: "white",
        border: "none",
        padding: "8px 12px",
        borderRadius: 6,
        cursor: "pointer",
      }}
    >
      Request an API Key
    </button>
  );
}
